export enum AgreementType {
  Default = 'Standard',
  Custom = 'Custom',
}
